







































































































































































import {mapActions, mapGetters} from 'vuex';
import SearchInput from '@/components/search/SearchInput.vue';
import Vue, {PropType} from 'vue';
import {Advert} from '#/Advert';

interface ComponentData {
  dialog: { display: boolean };
  dialogMessage: { display: boolean };
  filterSliderActive: boolean;
  navSliderActive: boolean;
}

interface ModalType {
  type: 'delete' | 'publish' | 'archive';
  action: () => void;
}

export default Vue.extend({
  name: 'AppBar',

  components: {SearchInput},

  props: {
    displayDialog: {
      required: true,
      type: Boolean as PropType<boolean>,
    },
    sideMenuActive: {
      required: true,
      type: Boolean as PropType<boolean>,
    },
  },

  data: (): ComponentData => ({
    dialog: {display: false},
    dialogMessage: {display: false},
    filterSliderActive: false,
    navSliderActive: false,
  }),

  computed: {
    ...mapGetters([
      'advert',
      'contextAppBar',
      'isOffline',
      'pageTitle',
      'profile',
      'searchOptions',
    ]),
    appBarColor(): 'grey darken-4' | 'primary' {
      return this.searchActive || this.contextAppBar.display ? 'grey darken-4' : 'primary';
    },
    isAdvertPage(): boolean {
      return this.$route.name === 'AdvertDetail' && !!(this.advert as Advert).id;
    },
    isArchive(): boolean {
      return this.isAdvertPage && this.advert.archivedAt !== null
          ? (this.advert.archivedAt.valueOf() < (new Date()).valueOf())
          : false;
    },
    isAuthor(): boolean {
      return this.isAdvertPage && this.profile ? this.advert.author.id === this.profile.id : false;
    },
    isDraft(): boolean {
      return this.isAdvertPage
          ? !(this.advert.isPublished || this.advert.archivedAt)
          : false;
    },
    modal(): ModalType {
      return this.isDraft
          ? {type: 'delete', action: this.onDelete}
          : this.isArchive
              ? {type: 'publish', action: this.onPublish}
              : {type: 'archive', action: this.onUnpublish};
    },
    searchActive(): boolean {
      return this.searchOptions.fieldOpen;
    },
  },

  methods: {
    ...mapActions([
      'archiveAdvert',
      'changeSearchFieldStatus',
      'deleteConversation',
      'displaySnackBar',
      'moderateAdvert',
      'saveDefaultSettings',
      'updateAdvert',
      'updateAppBarContext',
    ]),
    onInactiveSearch(): void {
      this.changeSearchFieldStatus(false);
    },
    onClickAppBarIcon(): void {
      if (this.searchActive) {
        this.onInactiveSearch();
      } else if (this.contextAppBar.display) {
        this.updateAppBarContext({
          display: false,
          type: '',
        });
        this.$router.go(-1);
      } else {
        this.$emit('update:side-menu-active', true);
        this.navSliderActive = false;
        this.filterSliderActive = false;
      }
    },
    onDelete(): void {
      this.dialog.display = false;
      this.moderateAdvert({id: this.advert.id, self: true});
    },
    onDeleteMessage(): void {
      const {advertId, userId} = this.$route.params;
      this.deleteConversation({advertId, userId});
      this.dialogMessage.display = false;
    },
    onPublish(): void {
      this.dialog.display = false;
      this.updateAdvert({id: this.advert.id, isPublished: true});
    },
    onSaveDefaultSettings(): void {
      this.saveDefaultSettings(true);
    },
    onShareAdvert(): void {
      const url = process.env.VUE_APP_BASE_URL_FRONT + this.$router.resolve({
        name: 'AdvertDetail',
        params: {advertId: this.$route.params.advertId},
      }).href;

      if (navigator.share) {
        navigator.share({
          title: this.advert.title,
          url,
        });
      } else {
        navigator.clipboard.writeText(url)
                 .then(() => {
                   this.displaySnackBar({
                     text: this.$t('advert.detail.share'),
                     type: 'valid',
                   });
                 });
      }
    },
    onSwitchSearchStatus(): void {
      this.changeSearchFieldStatus(!this.searchOptions.fieldOpen);
    },
    onUnpublish(): void {
      this.dialog.display = false;
      this.archiveAdvert({id: this.advert.id});
    },
  },
});
